<div [formGroup]="form">
  <div class="section-container" id="impostos-retidos">
    <div class="section-title">
      <mat-icon>trending_down</mat-icon>
      <span>Impostos Retidos</span>
    </div>
    <p class="text-muted small mb-3">Descontados do valor pago ao emitente · preencha apenas os efetivamente retidos.</p>

    <div class="row mb-3">
      <div class="col-12"><strong>IR</strong></div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Base (R$)</mat-label>
          <input matInput formControlName="irBase" [currencyMask]="dynamicCurrencyMask" (blur)="recalcular('ir')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Alíquota (%)</mat-label>
          <input matInput formControlName="irAliquota" [currencyMask]="percentageMask" (blur)="recalcular('ir')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor (R$)</mat-label>
          <input matInput formControlName="irValor" [currencyMask]="dynamicCurrencyMask" readonly />
        </mat-form-field>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12"><strong>INSS</strong></div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Base (R$)</mat-label>
          <input matInput formControlName="inssBase" [currencyMask]="dynamicCurrencyMask" (blur)="recalcular('inss')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Alíquota (%)</mat-label>
          <input matInput formControlName="inssAliquota" [currencyMask]="percentageMask" (blur)="recalcular('inss')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor (R$)</mat-label>
          <input matInput formControlName="inssValor" [currencyMask]="dynamicCurrencyMask" readonly />
        </mat-form-field>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12"><strong>ISS</strong></div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Base (R$)</mat-label>
          <input matInput formControlName="issBase" [currencyMask]="dynamicCurrencyMask" (blur)="recalcular('iss')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Alíquota (%)</mat-label>
          <input matInput formControlName="issAliquota" [currencyMask]="percentageMask" (blur)="recalcular('iss')" />
        </mat-form-field>
      </div>
      <div class="col-12 col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor (R$)</mat-label>
          <input matInput formControlName="issValor" [currencyMask]="dynamicCurrencyMask" readonly />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-4">
        <div class="row">
          <div class="col-12"><strong>PIS</strong></div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Alíquota (%)</mat-label>
              <input matInput formControlName="pisRetidoAliquota" [currencyMask]="percentageMask" (blur)="recalcularSemBase('pisRetido')" />
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor (R$)</mat-label>
              <input matInput formControlName="pisRetidoValor" [currencyMask]="dynamicCurrencyMask" readonly />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="row">
          <div class="col-12"><strong>COFINS</strong></div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Alíquota (%)</mat-label>
              <input matInput formControlName="cofinsRetidoAliquota" [currencyMask]="percentageMask" (blur)="recalcularSemBase('cofinsRetido')" />
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor (R$)</mat-label>
              <input matInput formControlName="cofinsRetidoValor" [currencyMask]="dynamicCurrencyMask" readonly />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-4">
        <div class="row">
          <div class="col-12"><strong>CSLL</strong></div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Alíquota (%)</mat-label>
              <input matInput formControlName="csllRetidoAliquota" [currencyMask]="percentageMask" (blur)="recalcularSemBase('csllRetido')" />
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor (R$)</mat-label>
              <input matInput formControlName="csllRetidoValor" [currencyMask]="dynamicCurrencyMask" readonly />
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
